const defaultWebsiteCurrency = 'USD';

export default defaultWebsiteCurrency;
